import { IndicationSummaryGetResponse } from '@lio/api-types';
import { LoginSource, LoginView, RegistrationRole } from '@pages/Login/constants';
import { PresetSignUpWrapper } from '@pages/Login/SignUpView/PresetSignUpWrapper';
import { RegistrationRoleSelectionView } from '@pages/Login/SignUpView/RegistrationRoleSelectionView';
import { SignUpView } from '@pages/Login/SignUpView/SignUpView';

export const renderView = ({
  view,
  loginSource,
  indicationSummary,
  isApiPartnerIndication,
  isRoleSelectionRequested = false,
  selectedRole,
  onRoleSelect,
  onSelectDifferentRole,
  redirectUrl,
}: {
  view?: LoginView;
  loginSource: LoginSource;
  indicationSummary?: IndicationSummaryGetResponse;
  isApiPartnerIndication: boolean;
  isRoleSelectionRequested?: boolean;
  selectedRole?: RegistrationRole;
  onRoleSelect: (role: RegistrationRole) => void;
  onSelectDifferentRole: () => void;
  redirectUrl?: string;
}) => {
  switch (view) {
    case LoginView.SIGNUP: {
      const shouldShowRoleSelection =
        loginSource === LoginSource.LOGIN ||
        (loginSource === LoginSource.INDICATION && (!isApiPartnerIndication || isRoleSelectionRequested));

      if (shouldShowRoleSelection) {
        if (!selectedRole) {
          return <RegistrationRoleSelectionView onRoleSelect={onRoleSelect} />;
        }
        return (
          <SignUpView
            loginSource={loginSource}
            indicationSummary={indicationSummary}
            registrationRole={selectedRole}
            onSelectDifferentRole={onSelectDifferentRole}
          />
        );
      }

      if (loginSource === LoginSource.INDICATION && isApiPartnerIndication) {
        return (
          <SignUpView
            loginSource={loginSource}
            indicationSummary={indicationSummary}
            registrationRole={RegistrationRole.BROKER_PRODUCER}
            onSelectDifferentRole={onSelectDifferentRole}
          />
        );
      }

      return (
        <PresetSignUpWrapper loginSource={loginSource} redirectUrl={redirectUrl}>
          <SignUpView loginSource={loginSource} indicationSummary={indicationSummary} />
        </PresetSignUpWrapper>
      );
    }
    default:
      return null;
  }
};
